import React, {Component} from 'react';
import {
  SideBar
} from 'searchkit';
import Filters from './Filters';
import Responsive from 'react-responsive';
import classNames from 'classnames';

class Sidebar extends Component {
  constructor(props) {
    super();
    this.state = {
      filterVisible: false
    }
  }

  toggleFilters() {
    this.setState({
      filterVisible: !this.state.filterVisible
    })
  }

  render() {
    let Mobile = props => <Responsive {...props} maxWidth={960} />;
    const filterVisible = this.state.filterVisible;
    const toggleFilter = classNames({
      'filters-hidden': !filterVisible,
      'filters-visible': filterVisible
    })

    return (
      <SideBar>
        <Mobile>
          <h3 onClick={() => this.toggleFilters()}>Filters</h3>
        </Mobile>
        <div className={toggleFilter}>
          <Filters {...this.props} />
        </div>
      </SideBar>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/Sidebar.jsx